import * as actionTypes from './actionTypes';

import { createActionObject } from '../../helpers/common';

export const setKeyword = keyword => dispatch => dispatch(
  createActionObject(
    actionTypes.CHANGE_SEARCH_KEYWORD,
    { keyword }
  )
)

export const setUserName = userName => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_USER_NAME,
    { userName }
  )
)

export const setStatus = status => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_STATUS,
    { status }
  )
)